import { getSlugFromPath } from '@hopin-team/dashboard-shared';
import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const EventUtilizationEmptyState = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const slug = getSlugFromPath(pathname);

  const handleCreateEvent = () => {
    navigate(`/org/${slug}/create-event-wizard`);
  };

  return (
    <div className="flex flex-1 items-center gap-6 justify-around">
      <div className="flex w-kpi-event-left-panel shrink-0 flex-col items-center justify-center pt-kpi-top">
        <div className="flex h-11 items-start justify-center pt-2">
          <span
            className="text-kpi-percentage text-gray-900"
            data-testid="event-utilization-empty-events-created"
          >
            0
          </span>
        </div>
        <div className="flex h-kpi-label items-start justify-center pt-1">
          <span className="w-kpi-event-label text-center text-title text-neutral-b2">
            {t('analytics.admin.events-created')}
          </span>
        </div>
      </div>
      <div className="flex min-w-0 justify-end pr-6">
        <button
          onClick={handleCreateEvent}
          className="shrink-0 bg-blue-400 px-4 py-2 text-white rounded-lg hover:bg-blue-600 hover:text-white"
          data-testid="create-first-event-button"
        >
          {t('analytics.admin.create-first-event')}
        </button>
      </div>
    </div>
  );
};
